import React from 'react'
import { Section, CategoryList, PostDetails, Share } from 'newComponents'

import './styles.scss'

const BlogPostHeader = (props) => {
  const { title, categories, timestamp, hideDate, author, dataString, location } = props
  // content checks
  const titleHtml = title?.html

  return (
    <Section className="blog-post-header">
      <CategoryList categories={categories} />
      {titleHtml && <div dangerouslySetInnerHTML={{ __html: titleHtml }} className="blog-post-title" />}
      <div className="blog-post-header-details-share">
        <PostDetails author={author} timestamp={timestamp} hideDate={hideDate} dataString={dataString} />
        <Share location={location} title={title.text} />
      </div>
    </Section>
  )
}

export default BlogPostHeader
